import { render, staticRenderFns } from "./download.vue?vue&type=template&id=3119709b&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=3119709b&prod&lang=stylus&scoped=true"
import style1 from "./download.vue?vue&type=style&index=1&id=3119709b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119709b",
  null
  
)

export default component.exports